import { render } from "./TagAddData.vue?vue&type=template&id=2e48b766"
import script from "./TagAddData.vue?vue&type=script&lang=js"
export * from "./TagAddData.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__